<div class="model-detail-form-container">
  <ng-container *ngIf="!dataLoading; else skeletonLoader">
    <mat-card>
      <mat-card-title>{{ model ? 'Polish Your Act' : 'Create Model Profile' }}</mat-card-title>
      <form [formGroup]="modelForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="We won’t spam (probably)">
                <mat-error *ngIf="modelForm.get('email')?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="modelForm.get('email')?.hasError('email')">Invalid email</mat-error>
            </mat-form-field>
          <mat-form-field>
            <mat-label>Nickname</mat-label>
            <input matInput formControlName="name" placeholder="Obviously not your real name">
            <mat-error *ngIf="modelForm.get('name')?.hasError('required')">Nickname is required</mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-row">
      <mat-form-field>
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender" placeholder="Choose your flavour">
          <mat-option value="Female">Female</mat-option>
          <mat-option value="Male">Male</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
            </mat-form-field>
          <mat-form-field>
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date_of_birth" placeholder="MM/DD/YYYY">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="modelForm.get('date_of_birth')?.hasError('required')">Date of birth is required</mat-error>
            <mat-error *ngIf="modelForm.get('date_of_birth')?.hasError('minAge')">
              You must be at least 18 years old.
            </mat-error>
          </mat-form-field>
        </div>
  
        <mat-form-field>
          <mat-label>Bio</mat-label>
          <textarea matInput formControlName="description" maxlength="300" placeholder="keep it spicy and brag a little, it's allowed"></textarea>
        </mat-form-field>
  
        
    <mat-form-field>
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phone_number" placeholder="Only digits, no emojis">
          </mat-form-field>
  
      
    <mat-form-field class="file-input-field">
      <mat-label>Profile Image</mat-label>
      <input matInput [value]="selectedFileName" readonly placeholder="Something from your hidden files 😈">
      <button mat-button type="button" (click)="triggerFileInput('profile')">Choose File</button>
      <input id="profile-image" type="file" (change)="onFileSelected($event, 'profile')" hidden>
    </mat-form-field>

    <mat-form-field class="file-input-field">
      <mat-label>Profile Banner</mat-label>
      <input matInput [value]="selectedBannerFileName" readonly placeholder="A wide, beautiful banner">
      <button mat-button type="button" (click)="triggerFileInput('banner')">Choose File</button>
      <input id="profile-banner" type="file" (change)="onFileSelected($event, 'banner')" hidden>
    </mat-form-field>
        
        <!-- <button *ngIf="model && model.model_id" mat-stroked-button color="accent" style="margin-bottom: 16px;" [routerLink]="['/content-manager']">Manage Content</button> -->
           
        <!-- Add form fields for twitter_url, instagram_url, city, province, country -->
        <div class="form-row">
      <mat-form-field>
          <mat-label>Twitter Username</mat-label>
          <input matInput formControlName="twitter_username" placeholder="Enter your Twitter username">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Instagram Username</mat-label>
          <input matInput formControlName="instagram_username" placeholder="Enter your Instagram username">
        </mat-form-field>
        </div>
        <div class="form-row">
      <mat-form-field>
        <mat-label>City</mat-label>
        <input matInput formControlName="city" placeholder="Enter your city">
            </mat-form-field>
      <mat-form-field>
        <mat-label>Province</mat-label>
        <input matInput formControlName="province" placeholder="Enter your province">
            </mat-form-field>
      <mat-form-field>
        <mat-label>Country</mat-label>
        <input matInput formControlName="country" placeholder="Enter your country">
            </mat-form-field>
        </div>
  
        <button mat-raised-button color="primary" type="submit" [disabled]="loading">
          <ng-container *ngIf="!loading; else loadingTpl">{{ model ? 'Update' : 'Create' }}</ng-container>
          <ng-template #loadingTpl>
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </ng-template>
        </button>
        <button *ngIf="model && model.model_id" mat-stroked-button color="warn" (click)="onClose()" style="margin-top: 16px;">Close</button>
      </form>
    </mat-card>
  </ng-container>
  <ng-template #skeletonLoader>
    <mat-card>
      <mat-card-title>
        <app-skeleton [width]="180" [height]="28" [borderRadius]="6"></app-skeleton>
      </mat-card-title>
      <div style="padding: 16px 0;">
        <div style="display: flex; gap: 16px; margin-bottom: 16px;">
          <app-skeleton [width]="220" [height]="56" [borderRadius]="4"></app-skeleton>
          <app-skeleton [width]="220" [height]="56" [borderRadius]="4"></app-skeleton>
        </div>
        <div style="display: flex; gap: 16px; margin-bottom: 16px;">
          <app-skeleton [width]="220" [height]="56" [borderRadius]="4"></app-skeleton>
          <app-skeleton [width]="220" [height]="56" [borderRadius]="4"></app-skeleton>
        </div>
        <app-skeleton [width]="460" [height]="56" [borderRadius]="4" style="margin-bottom: 16px;"></app-skeleton>
        <app-skeleton [width]="460" [height]="56" [borderRadius]="4" style="margin-bottom: 24px;"></app-skeleton>
        <div style="display: flex; gap: 16px;">
          <app-skeleton [width]="120" [height]="36" [borderRadius]="18"></app-skeleton>
          <app-skeleton [width]="120" [height]="36" [borderRadius]="18"></app-skeleton>
        </div>
      </div>
    </mat-card>
  </ng-template>
</div>